// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddKnowledgeData, AddKnowledgeErrors, AddKnowledgeResponses, AddNoteData, AddNoteErrors, AddNoteResponses, AssignConversationData, AssignConversationErrors, AssignConversationResponses, CheckPasswordLinkData, CheckPasswordLinkErrors, CheckPasswordLinkResponses, CreateChannelAccountData, CreateChannelAccountErrors, CreateChannelAccountResponses, CreateContactData, CreateContactErrors, CreateContactResponses, CreateLabelData, CreateLabelErrors, CreateLabelResponses, CreateMemberData, CreateMemberErrors, CreateMemberResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, DeleteChannelAccountData, DeleteChannelAccountErrors, DeleteChannelAccountResponses, DeleteContactData, DeleteContactErrors, DeleteContactResponses, DeleteKnowledgeData, DeleteKnowledgeErrors, DeleteKnowledgeResponses, DeleteLabelData, DeleteLabelErrors, DeleteLabelResponses, DeleteMemberData, DeleteMemberErrors, DeleteMemberResponses, DeleteNoteData, DeleteNoteErrors, DeleteNoteResponses, DiscardDraftData, DiscardDraftErrors, DiscardDraftResponses, DraftCalibrationData, DraftCalibrationErrors, DraftCalibrationResponses, DraftMissesData, DraftMissesErrors, DraftMissesResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAgentSettingsData, GetAgentSettingsErrors, GetAgentSettingsResponses, GetChannelAccountData, GetChannelAccountErrors, GetChannelAccountResponses, GetContactData, GetContactErrors, GetContactResponses, GetConversationData, GetConversationErrors, GetConversationResponses, GetDraftData, GetDraftErrors, GetDraftResponses, GetKnowledgeData, GetKnowledgeErrors, GetKnowledgeResponses, GetMemberData, GetMemberErrors, GetMemberResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, InboxAnalyticsData, InboxAnalyticsErrors, InboxAnalyticsResponses, ListChannelAccountsData, ListChannelAccountsErrors, ListChannelAccountsResponses, ListContactIdentitiesData, ListContactIdentitiesErrors, ListContactIdentitiesResponses, ListContactsData, ListContactsErrors, ListContactsResponses, ListConversationsData, ListConversationsErrors, ListConversationsResponses, ListDraftsData, ListDraftsErrors, ListDraftsResponses, ListKnowledgeData, ListKnowledgeErrors, ListKnowledgeResponses, ListLabelsData, ListLabelsErrors, ListLabelsResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListMessagesData, ListMessagesErrors, ListMessagesResponses, ListNotesData, ListNotesErrors, ListNotesResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MeData, MeErrors, MeResponses, MintStreamTicketData, MintStreamTicketErrors, MintStreamTicketResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegenerateDraftData, RegenerateDraftErrors, RegenerateDraftResponses, RegisterData, RegisterErrors, RegisterResponses, ReplyData, ReplyErrors, ReplyResponses, ResendVerificationData, ResendVerificationErrors, ResendVerificationResponses, SetAgentDialData, SetAgentDialErrors, SetAgentDialResponses, SetAgentPersonaData, SetAgentPersonaErrors, SetAgentPersonaResponses, SetChannelAccountEnabledData, SetChannelAccountEnabledErrors, SetChannelAccountEnabledResponses, SetChannelAccountSecretData, SetChannelAccountSecretErrors, SetChannelAccountSecretResponses, SetContactNotesData, SetContactNotesErrors, SetContactNotesResponses, SetConversationStatusData, SetConversationStatusErrors, SetConversationStatusResponses, SetConversationTagsData, SetConversationTagsErrors, SetConversationTagsResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, SnoozeConversationData, SnoozeConversationErrors, SnoozeConversationResponses, UpdateContactData, UpdateContactErrors, UpdateContactResponses, UpdateMemberData, UpdateMemberErrors, UpdateMemberResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * What became of the drafts in each confidence decile
 *
 * The basis for deciding where to put the dial: a decile where a person had to fix most drafts is a decile the dial should not reach.
 */
export const draftCalibration = <ThrowOnError extends boolean = false>(options: Options<DraftCalibrationData, ThrowOnError>): RequestResult<DraftCalibrationResponses, DraftCalibrationErrors, ThrowOnError> => (options.client ?? client).get<DraftCalibrationResponses, DraftCalibrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/calibration',
    ...options
});

/**
 * Whether a draft may go out without a person
 *
 * Off by default. On, a draft still has to clear four more gates: the agent did not flag it, its confidence meets the threshold, its intent is allowed, and the thread is open and unclaimed. Every one is re-checked at send time.
 */
export const setAgentDial = <ThrowOnError extends boolean = false>(options: Options<SetAgentDialData, ThrowOnError>): RequestResult<SetAgentDialResponses, SetAgentDialErrors, ThrowOnError> => (options.client ?? client).put<SetAgentDialResponses, SetAgentDialErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/dial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Drafts a person had to correct
 *
 * Edited or discarded, newest first — the two ways the agent was wrong.
 */
export const draftMisses = <ThrowOnError extends boolean = false>(options: Options<DraftMissesData, ThrowOnError>): RequestResult<DraftMissesResponses, DraftMissesErrors, ThrowOnError> => (options.client ?? client).get<DraftMissesResponses, DraftMissesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/misses',
    ...options
});

/**
 * Who the agent answers as, and the house rules
 *
 * Appended after the agent's own rules, never instead of them.
 */
export const setAgentPersona = <ThrowOnError extends boolean = false>(options: Options<SetAgentPersonaData, ThrowOnError>): RequestResult<SetAgentPersonaResponses, SetAgentPersonaErrors, ThrowOnError> => (options.client ?? client).put<SetAgentPersonaResponses, SetAgentPersonaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/persona',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The persona and the dial
 */
export const getAgentSettings = <ThrowOnError extends boolean = false>(options: Options<GetAgentSettingsData, ThrowOnError>): RequestResult<GetAgentSettingsResponses, GetAgentSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetAgentSettingsResponses, GetAgentSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/settings',
    ...options
});

/**
 * Whether the inbox is working
 *
 * Volumes, where the work came from, how much of the answering the agent did, and the median time to a first answer — the median, because one thread answered after a fortnight drags an average somewhere nobody recognises.
 */
export const inboxAnalytics = <ThrowOnError extends boolean = false>(options: Options<InboxAnalyticsData, ThrowOnError>): RequestResult<InboxAnalyticsResponses, InboxAnalyticsErrors, ThrowOnError> => (options.client ?? client).get<InboxAnalyticsResponses, InboxAnalyticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analytics',
    ...options
});

/**
 * Mail the confirmation link again
 *
 * Answers the same whether or not the address has an unconfirmed account.
 */
export const resendVerification = <ThrowOnError extends boolean = false>(options: Options<ResendVerificationData, ThrowOnError>): RequestResult<ResendVerificationResponses, ResendVerificationErrors, ThrowOnError> => (options.client ?? client).post<ResendVerificationResponses, ResendVerificationErrors, ThrowOnError>({
    url: '/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an address with a mailed link's token
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>): RequestResult<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError> => (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    url: '/auth/email/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 *
 * Returns an access token for the Authorization header and a refresh token to renew it.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End the session a refresh token belongs to
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> => (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    url: '/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether a mailed link's token can still set a password
 *
 * Does not spend the token; lets the page say a link has expired before a password is typed.
 */
export const checkPasswordLink = <ThrowOnError extends boolean = false>(options: Options<CheckPasswordLinkData, ThrowOnError>): RequestResult<CheckPasswordLinkResponses, CheckPasswordLinkErrors, ThrowOnError> => (options.client ?? client).post<CheckPasswordLinkResponses, CheckPasswordLinkErrors, ThrowOnError>({
    url: '/auth/password/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mail a link to choose a new password
 *
 * Answers the same whether or not the address has an account.
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Choose a password with a mailed link's token
 *
 * Ends every session the account had.
 */
export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>): RequestResult<SetPasswordResponses, SetPasswordErrors, ThrowOnError> => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    url: '/auth/password/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trade a refresh token for fresh tokens
 *
 * The refresh token is single use: the response carries its replacement.
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an account
 *
 * Mails a link that confirms the address. Nothing can be signed into until it is followed.
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>): RequestResult<RegisterResponses, RegisterErrors, ThrowOnError> => (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
    url: '/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The mailboxes and bots this workspace uses
 *
 * The stored password is never returned; `hasSecret` says whether there is one.
 */
export const listChannelAccounts = <ThrowOnError extends boolean = false>(options: Options<ListChannelAccountsData, ThrowOnError>): RequestResult<ListChannelAccountsResponses, ListChannelAccountsErrors, ThrowOnError> => (options.client ?? client).get<ListChannelAccountsResponses, ListChannelAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/channel-accounts',
    ...options
});

/**
 * Connect a mailbox or a bot
 */
export const createChannelAccount = <ThrowOnError extends boolean = false>(options: Options<CreateChannelAccountData, ThrowOnError>): RequestResult<CreateChannelAccountResponses, CreateChannelAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateChannelAccountResponses, CreateChannelAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/channel-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect an account
 *
 * The conversations it received stay; they simply no longer name an account to reply from.
 */
export const deleteChannelAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteChannelAccountData, ThrowOnError>): RequestResult<DeleteChannelAccountResponses, DeleteChannelAccountErrors, ThrowOnError> => (options.client ?? client).delete<DeleteChannelAccountResponses, DeleteChannelAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/channel-accounts/{id}',
    ...options
});

/**
 * One account
 */
export const getChannelAccount = <ThrowOnError extends boolean = false>(options: Options<GetChannelAccountData, ThrowOnError>): RequestResult<GetChannelAccountResponses, GetChannelAccountErrors, ThrowOnError> => (options.client ?? client).get<GetChannelAccountResponses, GetChannelAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/channel-accounts/{id}',
    ...options
});

/**
 * Stop or start polling an account
 */
export const setChannelAccountEnabled = <ThrowOnError extends boolean = false>(options: Options<SetChannelAccountEnabledData, ThrowOnError>): RequestResult<SetChannelAccountEnabledResponses, SetChannelAccountEnabledErrors, ThrowOnError> => (options.client ?? client).post<SetChannelAccountEnabledResponses, SetChannelAccountEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/channel-accounts/{id}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace the stored password or token
 */
export const setChannelAccountSecret = <ThrowOnError extends boolean = false>(options: Options<SetChannelAccountSecretData, ThrowOnError>): RequestResult<SetChannelAccountSecretResponses, SetChannelAccountSecretErrors, ThrowOnError> => (options.client ?? client).put<SetChannelAccountSecretResponses, SetChannelAccountSecretErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/channel-accounts/{id}/secret',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The people who have written in
 *
 * Filter properties: displayName, email, tag, createdAt. Sort keys: displayName, email, createdAt.
 */
export const listContacts = <ThrowOnError extends boolean = false>(options: Options<ListContactsData, ThrowOnError>): RequestResult<ListContactsResponses, ListContactsErrors, ThrowOnError> => (options.client ?? client).get<ListContactsResponses, ListContactsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts',
    ...options
});

/**
 * Add somebody by hand
 *
 * Most contacts are not created this way — they arrive with a message.
 */
export const createContact = <ThrowOnError extends boolean = false>(options: Options<CreateContactData, ThrowOnError>): RequestResult<CreateContactResponses, CreateContactErrors, ThrowOnError> => (options.client ?? client).post<CreateContactResponses, CreateContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a contact and their conversations
 */
export const deleteContact = <ThrowOnError extends boolean = false>(options: Options<DeleteContactData, ThrowOnError>): RequestResult<DeleteContactResponses, DeleteContactErrors, ThrowOnError> => (options.client ?? client).delete<DeleteContactResponses, DeleteContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{id}',
    ...options
});

/**
 * One contact
 */
export const getContact = <ThrowOnError extends boolean = false>(options: Options<GetContactData, ThrowOnError>): RequestResult<GetContactResponses, GetContactErrors, ThrowOnError> => (options.client ?? client).get<GetContactResponses, GetContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{id}',
    ...options
});

/**
 * Correct who somebody is
 */
export const updateContact = <ThrowOnError extends boolean = false>(options: Options<UpdateContactData, ThrowOnError>): RequestResult<UpdateContactResponses, UpdateContactErrors, ThrowOnError> => (options.client ?? client).patch<UpdateContactResponses, UpdateContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Every way of reaching them
 */
export const listContactIdentities = <ThrowOnError extends boolean = false>(options: Options<ListContactIdentitiesData, ThrowOnError>): RequestResult<ListContactIdentitiesResponses, ListContactIdentitiesErrors, ThrowOnError> => (options.client ?? client).get<ListContactIdentitiesResponses, ListContactIdentitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{id}/identities',
    ...options
});

/**
 * What the team knows about them
 *
 * Internal. The contact never sees it.
 */
export const setContactNotes = <ThrowOnError extends boolean = false>(options: Options<SetContactNotesData, ThrowOnError>): RequestResult<SetContactNotesResponses, SetContactNotesErrors, ThrowOnError> => (options.client ?? client).put<SetContactNotesResponses, SetContactNotesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The inbox
 *
 * Filter properties: status, assignee, assigneeId, contactId, channel, tag, waiting, lastMessageAt, createdAt. Sort keys: lastMessageAt, createdAt, subject, awaitingSince. The screen an operator opens is a saved filter over this.
 */
export const listConversations = <ThrowOnError extends boolean = false>(options: Options<ListConversationsData, ThrowOnError>): RequestResult<ListConversationsResponses, ListConversationsErrors, ThrowOnError> => (options.client ?? client).get<ListConversationsResponses, ListConversationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations',
    ...options
});

/**
 * One thread
 */
export const getConversation = <ThrowOnError extends boolean = false>(options: Options<GetConversationData, ThrowOnError>): RequestResult<GetConversationResponses, GetConversationErrors, ThrowOnError> => (options.client ?? client).get<GetConversationResponses, GetConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}',
    ...options
});

/**
 * Hand a thread to somebody
 *
 * A member id is required exactly when the assignee is a member.
 */
export const assignConversation = <ThrowOnError extends boolean = false>(options: Options<AssignConversationData, ThrowOnError>): RequestResult<AssignConversationResponses, AssignConversationErrors, ThrowOnError> => (options.client ?? client).post<AssignConversationResponses, AssignConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What the agent would say
 */
export const getDraft = <ThrowOnError extends boolean = false>(options: Options<GetDraftData, ThrowOnError>): RequestResult<GetDraftResponses, GetDraftErrors, ThrowOnError> => (options.client ?? client).get<GetDraftResponses, GetDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/draft',
    ...options
});

/**
 * Every draft this thread has had, newest first
 *
 * Superseded drafts are kept: what the agent said before an operator added a knowledge document is the evidence that adding it helped.
 */
export const listDrafts = <ThrowOnError extends boolean = false>(options: Options<ListDraftsData, ThrowOnError>): RequestResult<ListDraftsResponses, ListDraftsErrors, ThrowOnError> => (options.client ?? client).get<ListDraftsResponses, ListDraftsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/drafts',
    ...options
});

/**
 * Draft again, now
 *
 * After adding knowledge or changing the instructions. Seeing the improvement now beats waiting for the customer to write again.
 */
export const regenerateDraft = <ThrowOnError extends boolean = false>(options: Options<RegenerateDraftData, ThrowOnError>): RequestResult<RegenerateDraftResponses, RegenerateDraftErrors, ThrowOnError> => (options.client ?? client).post<RegenerateDraftResponses, RegenerateDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/drafts/regenerate',
    ...options
});

/**
 * The thread itself, oldest first
 */
export const listMessages = <ThrowOnError extends boolean = false>(options: Options<ListMessagesData, ThrowOnError>): RequestResult<ListMessagesResponses, ListMessagesErrors, ThrowOnError> => (options.client ?? client).get<ListMessagesResponses, ListMessagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/messages',
    ...options
});

/**
 * What the team said about this thread
 *
 * Internal. A note is never sent, never rendered into a reply, and never reaches the model.
 */
export const listNotes = <ThrowOnError extends boolean = false>(options: Options<ListNotesData, ThrowOnError>): RequestResult<ListNotesResponses, ListNotesErrors, ThrowOnError> => (options.client ?? client).get<ListNotesResponses, ListNotesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/notes',
    ...options
});

/**
 * Leave a note for the team
 */
export const addNote = <ThrowOnError extends boolean = false>(options: Options<AddNoteData, ThrowOnError>): RequestResult<AddNoteResponses, AddNoteErrors, ThrowOnError> => (options.client ?? client).post<AddNoteResponses, AddNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Answer the customer
 *
 * Sends on whichever channel the thread is on, from the identity it arrived through, and records it. Delivery comes first: a thread showing an answer the customer never got is the failure nobody notices.
 */
export const reply = <ThrowOnError extends boolean = false>(options: Options<ReplyData, ThrowOnError>): RequestResult<ReplyResponses, ReplyErrors, ThrowOnError> => (options.client ?? client).post<ReplyResponses, ReplyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Park a thread until later
 *
 * It comes back open. If the customer never wrote in the meantime it comes back tagged 'follow-up', because then a nudge is due rather than an answer.
 */
export const snoozeConversation = <ThrowOnError extends boolean = false>(options: Options<SnoozeConversationData, ThrowOnError>): RequestResult<SnoozeConversationResponses, SnoozeConversationErrors, ThrowOnError> => (options.client ?? client).post<SnoozeConversationResponses, SnoozeConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/snooze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open, snooze or close a thread
 */
export const setConversationStatus = <ThrowOnError extends boolean = false>(options: Options<SetConversationStatusData, ThrowOnError>): RequestResult<SetConversationStatusResponses, SetConversationStatusErrors, ThrowOnError> => (options.client ?? client).post<SetConversationStatusResponses, SetConversationStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What the thread is about
 */
export const setConversationTags = <ThrowOnError extends boolean = false>(options: Options<SetConversationTagsData, ThrowOnError>): RequestResult<SetConversationTagsResponses, SetConversationTagsErrors, ThrowOnError> => (options.client ?? client).put<SetConversationTagsResponses, SetConversationTagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/conversations/{id}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Throw a draft away
 *
 * It stays on record: a discarded draft is the clearest signal the agent gets.
 */
export const discardDraft = <ThrowOnError extends boolean = false>(options: Options<DiscardDraftData, ThrowOnError>): RequestResult<DiscardDraftResponses, DiscardDraftErrors, ThrowOnError> => (options.client ?? client).post<DiscardDraftResponses, DiscardDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/drafts/{id}/discard',
    ...options
});

/**
 * A ticket for the live feed
 *
 * EventSource cannot send an Authorization header, so the stream is opened with this instead. Single-use, one minute, and it carries only the workspace.
 */
export const mintStreamTicket = <ThrowOnError extends boolean = false>(options: Options<MintStreamTicketData, ThrowOnError>): RequestResult<MintStreamTicketResponses, MintStreamTicketErrors, ThrowOnError> => (options.client ?? client).post<MintStreamTicketResponses, MintStreamTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/events/ticket',
    ...options
});

/**
 * What the agent is allowed to know
 */
export const listKnowledge = <ThrowOnError extends boolean = false>(options: Options<ListKnowledgeData, ThrowOnError>): RequestResult<ListKnowledgeResponses, ListKnowledgeErrors, ThrowOnError> => (options.client ?? client).get<ListKnowledgeResponses, ListKnowledgeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge',
    ...options
});

/**
 * Write something the agent may use
 *
 * Indexed as it is written, so the next regenerated draft can already cite it. A deployment with no embedder still stores it; the drafts are simply ungrounded.
 */
export const addKnowledge = <ThrowOnError extends boolean = false>(options: Options<AddKnowledgeData, ThrowOnError>): RequestResult<AddKnowledgeResponses, AddKnowledgeErrors, ThrowOnError> => (options.client ?? client).post<AddKnowledgeResponses, AddKnowledgeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Take a document away from the agent
 */
export const deleteKnowledge = <ThrowOnError extends boolean = false>(options: Options<DeleteKnowledgeData, ThrowOnError>): RequestResult<DeleteKnowledgeResponses, DeleteKnowledgeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteKnowledgeResponses, DeleteKnowledgeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge/{id}',
    ...options
});

/**
 * One document
 */
export const getKnowledge = <ThrowOnError extends boolean = false>(options: Options<GetKnowledgeData, ThrowOnError>): RequestResult<GetKnowledgeResponses, GetKnowledgeErrors, ThrowOnError> => (options.client ?? client).get<GetKnowledgeResponses, GetKnowledgeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge/{id}',
    ...options
});

/**
 * This workspace's own words for its threads
 */
export const listLabels = <ThrowOnError extends boolean = false>(options: Options<ListLabelsData, ThrowOnError>): RequestResult<ListLabelsResponses, ListLabelsErrors, ThrowOnError> => (options.client ?? client).get<ListLabelsResponses, ListLabelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/labels',
    ...options
});

/**
 * Invent one
 */
export const createLabel = <ThrowOnError extends boolean = false>(options: Options<CreateLabelData, ThrowOnError>): RequestResult<CreateLabelResponses, CreateLabelErrors, ThrowOnError> => (options.client ?? client).post<CreateLabelResponses, CreateLabelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/labels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Take a word out of the palette
 *
 * Threads already tagged with it keep the tag: this removes the label, not the history.
 */
export const deleteLabel = <ThrowOnError extends boolean = false>(options: Options<DeleteLabelData, ThrowOnError>): RequestResult<DeleteLabelResponses, DeleteLabelErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLabelResponses, DeleteLabelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/labels/{id}',
    ...options
});

/**
 * The caller and their organisations
 */
export const me = <ThrowOnError extends boolean = false>(options?: Options<MeData, ThrowOnError>): RequestResult<MeResponses, MeErrors, ThrowOnError> => (options?.client ?? client).get<MeResponses, MeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options
});

/**
 * List members
 *
 * Filter properties: role, displayName, createdAt. Sort keys: displayName, role, createdAt.
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members',
    ...options
});

/**
 * Seat a subject in the organisation
 */
export const createMember = <ThrowOnError extends boolean = false>(options: Options<CreateMemberData, ThrowOnError>): RequestResult<CreateMemberResponses, CreateMemberErrors, ThrowOnError> => (options.client ?? client).post<CreateMemberResponses, CreateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a member
 */
export const deleteMember = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberData, ThrowOnError>): RequestResult<DeleteMemberResponses, DeleteMemberErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMemberResponses, DeleteMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options
});

/**
 * Get a member
 */
export const getMember = <ThrowOnError extends boolean = false>(options: Options<GetMemberData, ThrowOnError>): RequestResult<GetMemberResponses, GetMemberErrors, ThrowOnError> => (options.client ?? client).get<GetMemberResponses, GetMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options
});

/**
 * Rename a member or change their role
 */
export const updateMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberData, ThrowOnError>): RequestResult<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove your own note
 *
 * Only the person who wrote it.
 */
export const deleteNote = <ThrowOnError extends boolean = false>(options: Options<DeleteNoteData, ThrowOnError>): RequestResult<DeleteNoteResponses, DeleteNoteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteNoteResponses, DeleteNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/{id}',
    ...options
});

/**
 * The current organisation
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization',
    ...options
});

/**
 * Rename the organisation
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Found an organisation
 *
 * The caller becomes its first owner.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
